import { render, staticRenderFns } from "./HistoryDetail.vue?vue&type=template&id=2decd87d&"
import script from "./HistoryDetail.vue?vue&type=script&lang=js&"
export * from "./HistoryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports